import { FiArchive, FiArrowDown, FiBell, FiBellOff, FiCheck, FiChevronDown, FiFlag, FiImage, FiMenu, FiMic, FiMoreHorizontal, FiMoreVertical, FiPause, FiPhone, FiPlay, FiPlus, FiRepeat, FiSearch, FiSend, FiSmile, FiTrash, FiTrash2, FiUser, FiUsers, FiVideo, FiVolume, FiVolumeX, FiX, FiXOctagon } from "react-icons/fi"
import { neonUsers } from "../../../../dummy/users"
import React, { useState } from "react"
import clx from "classnames"
import { useModal } from "../../../../stores/useModal"
import neonStore from "../../../../stores/useNeon"

export const Sidebar = ({mobile}) => {
  const {open} = useModal(state=>state)
  const {setConversation} = neonStore(state=>state)

   const createGroup = () => {
    open({type:'create-group', values:{} })
   }
    
    return (
        <React.Fragment>
                <div className={clx(
                  !mobile ? 'hidden lg:flex': ' flex',
                  'sidebar col-span-3'
                )}>
                <div className="bg-gray-100 dark:bg-[#12171d] p-3 -invisible">
                    <ul className="grid gap-4 overflow-x-auto h-screen">
                    <li class=""
                      onClick={createGroup}
                    >
                      <div class="cursor-pointer h-12 b-12 border border-gray-500 text-gray-500 dark:hover:bg-zinc-800 hover:bg-gray-300 rounded-full flex items-center justify-center">
                          <FiPlus size={23} />
                      </div>
                    </li>
                    {[
                        "/images/brands/github.png",
                        "/images/brands/evernote.png",
                        "/images/brands/google.png",
                        "/images/brands/mailchimp.png",
                        "/images/brands/sketch.png",
                        "/images/brands/medium.png",
                        "/images/brands/notion.png",
                        "/images/brands/instagram.png",
                        "/images/brands/airbnb.png",
                        "/images/brands/mongo.png",
                        "/images/brands/gitlab.png",
                        "/images/brands/youtube.png"
                    ].map((brand,i)=>(
                        <li key={`brand-${i}`}>
                        <div className="cursor-pointer">
                            <img src={brand} />
                        </div>
                    </li>
                    ))}
                    
                    </ul>
                </div>
                <div
                    className="messages bg-gray-50 dark:bg-[#1e2126] w-full overflow-x-auto h-screen"
                >
                    <div className="search">
                    <div
                        className="bg-gray-200 dark:bg-[#111] mx-4 my-4 flex items-center px-3 rounded-md"
                    >
                        <FiSearch size={23} className="stroke-gray-500"/>
                        <input
                        placeholder="Search"
                        type="text"
                        className="w-full border-none bg-transparent p-3 outline-none"
                        />
                    </div>
                    </div>
                    <div
                    onClick={createGroup}
                    // @click="createModal=!createModal"
                    className="start text-white bg-[#2b4dff] p-3 flex items-center justify-center mx-4 my-4 rounded-md cursor-pointer shadow-lg hover:shadow-xl hover:shadow-indigo-500/80 shadow-indigo-500/50"
                    >
                    Start new chat
                    </div>
                    {/** USERS **/}

                    <ul className="mx-2">
                        {neonUsers.map((user,i)=>(
                            <li
                            onClick={()=>{
                              setConversation(i)
                            }}
                            key={`user-${i}`}
                            className="group relative flex items-end gap-3 items-center dark:hover:bg-zinc-900 hover:bg-gray-200/50 rounded-md p-3 cursor-pointer"
                            >
                            <div className="relative flex flex-col items-center">
                                                
                                {user.type==4 && (
                                    <div className="relative flex flex-col items-center">
                                    <img
                                            src={user?.members[0]}
                                            className="h-10 cursor-pointer border border-2 rounded-full"
                                    />
                                    <div className="flex -mt-4">
                                        <img
                                            src={user?.members[1]}
                                            className="h-10 cursor-pointer border border-2 rounded-full"
                                        />
                                        <img
                                            src={user?.members[2]}
                                            className="-ml-3 h-10 cursor-pointer border border-2 rounded-full"
                                        />
                                    </div>
                                    </div>
                                )}

                                { user.type==3 && ( // user?.group && user.members?.length >= 2 &&
                                    <React.Fragment>
                                        <img
                                        src={user?.members[0]}
                                        className="h-10 cursor-pointer border border-2 rounded-full"
                                        />
                                        <div className="flex -mt-4">
                                        <img
                                            src={user?.members[1]}
                                            className="h-10 cursor-pointer border border-2 rounded-full"
                                        />
                                        {user.count && (
                                            <div
                                            style={{background:user.color}}
                                            className="-ml-3 h-10 w-10 text-white flex items-center justify-center text-center font-semibold cursor-pointer border border-2 rounded-full"
                                            >
                                            +{user.count}
                                            </div>
                                        )}
                                        </div>
                                    </React.Fragment>
                                )}

                                {user.type==2 && (
                                        <div className="flex">
                                        <img
                                            src={user.members[0]}
                                            className="h-10 cursor-pointer border border-2 rounded-full"
                                        />
                                            <img
                                            src={user.members[1]}
                                            className="-ml-3 h-10 cursor-pointer border border-2 rounded-full"
                                        />
                                        </div>
                                )}

                                {user.type==1 && (
                                    <div className="flex">
                                    <img
                                        src={user.members[0]}
                                        className="h-10 cursor-pointer border border-2 rounded-full"
                                    />
                                    <div
                                        style={{background:user.color}}
                                        className="-ml-3 h-10 w-10 text-white flex items-center justify-center text-center font-semibold cursor-pointer border border-2 rounded-full"
                                    >
                                        {user.count}
                                    </div>
                                    </div>
                                )}

                                {!user.type && user.count && (
                                    <div
                                    style={{background:user.color}}
                                    className="h-10 w-10 text-white bg-gray-300 dark:bg-[#fdad00] flex items-center justify-center text-center font-semibold cursor-pointer border border-2 rounded-full"
                                    >
                                    {user.count}
                                    </div>
                                )}

                                {!user.type && !user.count && (
                                        <div
                                        className="cursor-pointer font-medium dark:font-normal text-zinc-600 dark:text-gray-100 text-graborder border-2 rounded-full"
                                    >
                                        <img 
                                        src={user.members[0]}
                                        className="h-10" />
                                    </div>
                                )}
                                
                            </div>
                            <div>
                                <div
                                className="cursor-pointer font-medium dark:font-normal text-zinc-600 dark:text-gray-100 flex items-center gap-1"
                                >
                                {user.unnotified && (
                                    <span className="muted">
                                    <FiBellOff size={23} className="h-4"/>
                                </span>
                                )}
                                {user.muted && (
                                    <span className="muted">
                                    <FiVolumeX size={23} className="h-5"/>
                                    </span>
                                )}
                                {user.name}
                                </div>
                                <div className="text-sm text-gray-500">
                                {user.typing && <p className="text-green-600 font-bold">Typing...</p> }
                                {!user.typing && user.message + '..' }
                                </div>
                            </div>
                
                            <DropdownAction group={user} />


                            </li>
                        ))}
                    </ul>
                        

                </div>
                </div>
        </React.Fragment>
    )
}

export default Sidebar;


export const DropdownAction = ({group}) => {

    const [status, setStatus] = useState(false);
  
    return (
      <React.Fragment>
        
          {/** DROPDOWN MENU **/}
          <div x-data="{status:false}" 
                onClick={()=>setStatus(!status)}
                // @click.away="status=false" 
                className="flex items-center h-full">
                          
                  <div className="h-full flex items-center justify-center absolute top-0 bottom-0 right-4">
                    <div className="group-hover:hidden -absolute right-3 top-2- -dark:bg-[#1e2126] dark:group-hover:bg-zinc-900 pl-2 flex flex-col justify-center h-full items-end text-end">
                      <div className="text-gray-600 text-sm flex items-end justify-end w-max mb-1">{group.date}</div>
                       {group.unread && <div className="bg-red-500 text-white w-5 h-5 font-bold text-xs rounded-full flex items-center justify-center">{group.unread}</div> }
                    </div>
  
                    <div className="-absolute right-3 top-5 hidden group-hover:flex bg-white/10 flex items-center p-1 w-7 h-7 rounded-full">
                        <FiMoreHorizontal className="text-gray-500 h-5" size={23} />
                    </div>
                  </div>
                    
                  <div
                  className={clx(
                    {'block':status},
                    {'hidden':!status},
                    `dropdown absolute right-3 top-16 shadow-md border dark:border-zinc-700 bg-zinc-100 dark:bg-zinc-800
                    z-20 divide-y dark:divide-zinc-700 rounded-lg  w-44`
                  )}>
  
                    
                      <ul className="py-2 text-sm dark:text-zinc-200">
                        <li 
                        // @click="call = true"
                        >
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiPhone size={23} className="h-4 " /> <p>Audio Call</p> </a>
                        </li>
                        <li>
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiVideo size={23} className="h-4 " />  <p>Video Call</p> </a>
                        </li>
                      </ul>
                      <ul className="py-2 text-sm dark:text-zinc-200 text-zinc-500">
                        <li>
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiBell size={23} className="h-4 " />  <p>Mute Notification</p> </a>
                        </li>                        
                      </ul>
                      <ul className="py-2 text-sm dark:text-zinc-200">
                        <li>
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiArchive size={23} className="h-4 " /> <p>Archive</p> </a>
                        </li>
                        <li>
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiFlag size={23} className="h-4 " />  <p>Report</p> </a>
                        </li>
                        <li>
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiXOctagon size={23} className="h-4 " />  <p>Delete</p> </a>
                        </li>
                      </ul>
  
                  </div> 
  
                </div>
      </React.Fragment>
    )
  }
  
  
  export const DropdownAction2 = () => {
    const [status, setStatus] = useState(false);
    return (
      <React.Fragment>
         {/** DROPDOWN MENU **/}
                <div 
                  onClick={()=>setStatus(!status)}
                  className={clx({'hidden':!status}, 'flex items-center h-full' )}
                  // @click.away="status=false"  
                >
                          
                  <div className="group-hover:hidden absolute right-3 top-2- dark:bg-[#1e2126] dark:group-hover:bg-zinc-900 pl-2 flex flex-col items-end text-end">
                    <div className="text-zinc-600 text-sm flex items-end justify-end w-max mb-1">8h</div>
                  </div>
  
                  <div className="absolute right-3 top-5 hidden group-hover:flex bg-white/10 flex items-center p-1 w-7 h-7 rounded-full">
                      <FiMoreHorizontal size={23} className="text-zinc-500 h-5"/>
                  </div>
                    
                  <div
                  // :className="status == true ? 'block' :'hidden'" 
                  className="dropdown absolute right-3 bottom-16 shadow-md border dark:border-zinc-700 bg-zinc-100 dark:bg-zinc-800
                  z-20 divide-y dark:divide-zinc-700 rounded-lg  w-44 ">
  
                    
                      <ul className="py-2 text-sm dark:text-zinc-200">
                        <li
                        //  @click="call = true"
                        >
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiPhone size={23} className="h-4 "/> <p>Audio Call</p> </a>
                        </li>
                        <li>
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiVideo size={23} className="h-4 "/>  <p>Video Call</p> </a>
                        </li>
                      </ul>
                      <ul className="py-2 text-sm dark:text-zinc-200 text-zinc-500">
                        <li>
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiBell size={23} className="h-4 "/>  <p>Mute Notification</p> </a>
                        </li>                        
                      </ul>
                      <ul className="py-2 text-sm dark:text-zinc-200">
                        <li>
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiArchive size={23} className="h-4 "/> <p>Archive</p> </a>
                        </li>
                        <li>
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiFlag size={23} className="h-4 "/>  <p>Report</p> </a>
                        </li>
                        <li>
                          <a href="#" className="block px-4 py-2 dark:hover:bg-zinc-700 hover:bg-zinc-300 bg-zinc-100 dark:bg-zinc-800 dark:hover:text-white flex gap-1 items-center"> <FiXOctagon size={23} className="h-4 " />  <p>Delete</p> </a>
                        </li>
                      </ul>
  
                  </div> 
  
                </div>
      </React.Fragment>
    )
  }
  